var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UsdzExporter } from './exporters/UsdzExporter';
import { GltfExporter } from './exporters/GltfExporter';
import { OrbitControlsCameraManager } from './cameraManager/OrbitControlsCameraManager';
import { HdrEnvironment } from './environment/HdrEnvironment';
import { ModelLoader } from './loaders/ModelLoader';
import { MaterialLoader } from './loaders/MaterialLoader';
import { ThreeJSViewRenderer } from './ThreeJSViewRenderer';
import { ConfiguratorView3D } from './ConfiguratorView3D';
import { JointManagerView3D } from './JointManagerView3D';
import { MaterialsLibrary } from './MaterialsLibrary';
import { ClTextureLoader } from './loaders/TextureLoader';
import { TextureLibrary } from './loaders/TextureLibrary';
import { MaterialManagerView3D } from './MaterialManagerView3D';
import { ConfiguratorRenderer } from './viewTree/ConfiguratorRenderer';
import { View3dPlugin } from './plugins/View3dPlugin';
export class View3dFactory {
    constructor(canvas) {
        this.canvas = canvas;
    }
    create(view3dConfiguration_1) {
        return __awaiter(this, arguments, void 0, function* (view3dConfiguration, plugin = new View3dPlugin()) {
            const usdzExporter = new UsdzExporter();
            const gltfExporter = new GltfExporter();
            const cameraManager = new OrbitControlsCameraManager();
            const hdrEnvironment = new HdrEnvironment(view3dConfiguration);
            const modelLoader = new ModelLoader();
            const textureLoader = new ClTextureLoader();
            const materialLoader = new MaterialLoader();
            const textureLibrary = new TextureLibrary(textureLoader);
            textureLibrary.addTextures(view3dConfiguration.assets.textures);
            const materialsLibrary = new MaterialsLibrary(materialLoader, textureLibrary);
            materialsLibrary.addMaterials(view3dConfiguration.assets.materials);
            const renderer = new ThreeJSViewRenderer(this.canvas, view3dConfiguration);
            renderer.autoClear = false;
            renderer.setClearColor(view3dConfiguration.clearColor);
            const threeJsView3d = new ConfiguratorView3D(this.canvas, view3dConfiguration, gltfExporter, usdzExporter, cameraManager, hdrEnvironment, modelLoader, materialsLibrary, renderer, plugin);
            yield threeJsView3d.init(view3dConfiguration);
            return threeJsView3d;
        });
    }
    createJointManager(configuration) {
        return __awaiter(this, void 0, void 0, function* () {
            const cameraManager = new OrbitControlsCameraManager();
            const hdrEnvironment = new HdrEnvironment({ hdr: configuration.hdr });
            const modelLoader = new ModelLoader();
            const _materialLoader = new MaterialLoader();
            const renderer = new ThreeJSViewRenderer(this.canvas, configuration);
            const jointManagerView3D = new JointManagerView3D(this.canvas, cameraManager, hdrEnvironment, modelLoader, renderer);
            yield jointManagerView3D.init(configuration);
            return jointManagerView3D;
        });
    }
    createMaterialManager(material, hdr) {
        return __awaiter(this, void 0, void 0, function* () {
            const cameraManager = new OrbitControlsCameraManager();
            const renderer = new ThreeJSViewRenderer(this.canvas, {});
            const materialManagerView3D = new MaterialManagerView3D(this.canvas, cameraManager, renderer, material, hdr);
            yield materialManagerView3D.init();
            return materialManagerView3D;
        });
    }
    createV2(view3dConfiguration_1, builder_1) {
        return __awaiter(this, arguments, void 0, function* (view3dConfiguration, builder, plugin = new View3dPlugin()) {
            const usdzExporter = new UsdzExporter();
            const gltfExporter = new GltfExporter();
            const cameraManager = new OrbitControlsCameraManager();
            const hdrEnvironment = new HdrEnvironment(view3dConfiguration, builder.assetsManager);
            const modelLoader = new ModelLoader();
            const textureLoader = new ClTextureLoader();
            const materialLoader = new MaterialLoader();
            const textureLibrary = new TextureLibrary(textureLoader);
            textureLibrary.addTextures(view3dConfiguration.assets.textures);
            const materialsLibrary = new MaterialsLibrary(materialLoader, textureLibrary);
            materialsLibrary.addMaterials(view3dConfiguration.assets.materials);
            const renderer = new ThreeJSViewRenderer(this.canvas, view3dConfiguration);
            renderer.autoClear = false;
            renderer.setClearColor(view3dConfiguration.clearColor);
            const threeJsView3d = new ConfiguratorRenderer(view3dConfiguration, builder, this.canvas, gltfExporter, usdzExporter, cameraManager, hdrEnvironment, modelLoader, materialsLibrary, renderer, plugin);
            yield threeJsView3d.init(view3dConfiguration);
            return threeJsView3d;
        });
    }
}
//# sourceMappingURL=View3dFactory.js.map